module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-6.6303a4d2.jpg";